var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-32 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 27,
    x: 0.5,
    y: 0.5,
    fill: "none",
    stroke: "#84829C",
    rx: 13.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2A3A",
    fillRule: "nonzero",
    d: "M37.818 12.94l3.03-3.03 1.132 1.13-3.03 3.031 3.03 3.03-1.132 1.132-3.03-3.03-3.03 3.03-1.132-1.132 3.03-3.03-3.03-3.03 1.132-1.132 3.03 3.03z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXs);
export default __webpack_public_path__ + "static/media/xs.58c5bd23ff973219b6df94f353951ff4.svg";
export { ForwardRef as ReactComponent };